module.exports = __webpack_public_path__ + "media/images/imagem_generico_associado-e0fe9172b99f8e9f90c922ab2af1acfb.png";